import { IUserCalendar } from '@commenda/types/src/user';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useUserCalendar(
  userId: string | undefined,
  eventSlug?: string
) {
  const requestBaseURI = userId ? `user/${userId}/calendar` : null;

  const requestURI =
    eventSlug && requestBaseURI
      ? `${requestBaseURI}?eventSlug=${eventSlug}`
      : requestBaseURI;

  const {
    data,
    error,
    mutate,
  }: {
    data?: IUserCalendar;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    requestURI,
    SWRFetcher(
      {
        method: 'GET',
      },
      ''
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
